import React from "react";
import s from "./Default.module.css"
import ToNews from "../News/ToNews";
import img from "../../assets/News/News110425.jpg"

const News110425 = ({ children, header }) => {

    return <div className={s.page}>
        <h2 style={{
            fontWeight: "normal",
            marginTop: "50px",
            color: "#3a4663",
            textAlign: "left",
            maxWidth: "1100px",
            margin: "40px auto",
            fontFamily: "Proxima Nova Lt"
        }}>
            Проведена стратегическая сессия «О совершенствовании деятельности органов опеки и попечительства»
        </h2>
        <div>
            <img src={img} />
        </div>
        <div style={{ fontFamily: "Proxima Nova Lt" }}>
            9 апреля 2025 г. <a href="https://edu.gov.ru/" style={{fontWeight: "bold"}}>Минпросвещения России</a> провело стратегическую сессию «О совершенствовании деятельности органов опеки и попечительства».
            <p></p>
            В мероприятии приняли участие команды (рабочие группы), сформированные из представителей исполнительных органов власти субъектов Российской Федерации, руководителей и специалистов организаций для детей-сирот, органов опеки и попечительства, представителей негосударственных некоммерческих организаций и научного сообщества, усыновителей, опекунов и приемных родителей, а также выпускников организаций для детей-сирот.
            <p></p>
            В фокусе внимания участников стратегической сессии – благополучие ребенка. Основные направления работы групп: разработка индивидуальных траекторий помощи ребенку, который сталкивается с различными жизненными ситуациями, а также совершенствование алгоритмов работы органов опеки и попечительства.
            <p></p>
            Справочно: полномочия по опеке и попечительству в отношении несовершеннолетних граждан осуществляют 2 316 органов опеки и попечительства с общей численностью специалистов 11 738 человек.
            <p></p>
            Обеспечение проведения стратегической сессии осуществлялось ФГБУ «Центр защиты прав и интересов детей» на площадке ФГБНУ «Институт коррекционной педагогики».
            <p></p>
        </div>
        <ToNews />
    </div>
}


export default News110425;